import React, { useEffect } from 'react'
import _filter from 'lodash/filter'
import _map from 'lodash/map'
import _isEqual from 'lodash/isEqual'

import Card from '../../_library/Card'
import FiltersNew from '../../_library/FiltersNew'

const CustomerFormFilters = props => {
  const {
    rowId,
    filters,
    setFilters,
    submissionFilterOptions,
    submissions,
    initialSubmissions,
    setSubmissions,
    cardClosed,
    handleCardClose,
  } = props
  const filteredFilterOptions = _map(submissionFilterOptions, item => ({
    ...item,
    options: _filter(item.options, option => option.formId === rowId),
  }))

  useEffect(() => {
    if (filters.length > 0) {
      const filteredSubmissions = _filter(initialSubmissions, item => {
        let found = true
        _map(filters, (filter, index) => {
          let found1 = 0

          if (filter.type === 'statuses' && item.status === filter.value) {
            found1 += 1
          }

          if (filter.type === 'tags' && (item.tags || []).includes(filter.value)) {
            found1 += 1
          }

          if (item?.field_capture?.find(({ value }) => value === filter.value)) {
            found1 += 1
          }

          if (filter.isNot) {
            found1 = found1 > 0 ? 0 : 1
          }
          if (filter.isAnd) {
            found = found && found1 > 0
          } else {
            found = found || found1 > 0
          }
        })
        return found
      })

      if (!_isEqual(submissions, filteredSubmissions)) {
        setSubmissions(currValue => ({
          ...currValue,
          [rowId]: { ...currValue[rowId], submissions: filteredSubmissions },
        }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, rowId, submissions])

  return (
    <Card
      icon={'fa-filter'}
      title={'Filters'}
      closed={cardClosed}
      handleClose={handleCardClose}
      className="filter-card"
    >
      <FiltersNew
        filters={[
          {
            label: 'Status',
            type: 'statuses',
            options: [
              { value: 'new', label: 'New' },
              { value: 'accepted', label: 'Accepted' },
              { value: 'declined', label: 'Declined' },
            ],
          },
          ...filteredFilterOptions,
        ]}
        onFiltersChange={filters => {
          setFilters(filters)
          if (!filters.length) {
            setSubmissions(currValue => ({
              ...currValue,
              [rowId]: { ...currValue[rowId], submissions: initialSubmissions },
            }))
          }
        }}
        value={filters}
      />
    </Card>
  )
}

export default CustomerFormFilters
